module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "searchbar-user",
    class: {
      'hotmart-pro': _vm.topBarConfig.user.ucode
    }
  }, [_c('div', {
    staticClass: "container no-padding"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('svg', {
    staticClass: "navbar-icon fa kp-panel-pop-up",
    attrs: {
      "viewBox": "0 0 30 30",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M21.5 19.25V2.75C21.5 1.53125 20.4688 0.5 19.25 0.5H2.75C1.48438 0.5 0.5 1.53125 0.5 2.75V19.25C0.5 20.5156 1.48438 21.5 2.75 21.5H19.25C20.4688 21.5 21.5 20.5156 21.5 19.25ZM2.75 20C2.32812 20 2 19.6719 2 19.25V2.75C2 2.375 2.32812 2 2.75 2H19.25C19.625 2 20 2.375 20 2.75V19.25C20 19.6719 19.625 20 19.25 20H2.75ZM12.5 6.875V6.125C12.5 5.9375 12.3125 5.75 12.125 5.75H5.375C5.14062 5.75 5 5.9375 5 6.125V6.875C5 7.10938 5.14062 7.25 5.375 7.25H12.125C12.3125 7.25 12.5 7.10938 12.5 6.875ZM17 11.375V10.625C17 10.4375 16.8125 10.25 16.625 10.25H5.375C5.14062 10.25 5 10.4375 5 10.625V11.375C5 11.6094 5.14062 11.75 5.375 11.75H16.625C16.8125 11.75 17 11.6094 17 11.375ZM9.5 15.875V15.125C9.5 14.9375 9.3125 14.75 9.125 14.75H5.375C5.14062 14.75 5 14.9375 5 15.125V15.875C5 16.1094 5.14062 16.25 5.375 16.25H9.125C9.3125 16.25 9.5 16.1094 9.5 15.875Z"
    }
  })]), _vm._v("\n      " + _vm._s(_vm.$t('index.title')) + "\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "subtitle"
  }, [_vm._v("\n      " + _vm._s(_vm.$t('index.subtitle')) + "\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "search-flex"
  }, [_c('label', {
    staticClass: "hide"
  }, [_c('input', {
    attrs: {
      "type": "text",
      "name": "q",
      "placeholder": _vm.$t('index.find_a_box')
    }
  }), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('div', {
    staticClass: "kp-filter-action"
  }, [_c('a', {
    staticClass: "none-mobile pull-right kp-button",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        return _vm.boxAdd()
      }
    }
  }, [_c('span', {
    staticClass: "icon-kp-plus",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(_vm._s(_vm.$t('general.actions.new')) + "\n        ")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "filter_search icon-search"
  }, [_c('i', {
    staticClass: "fa fa-search"
  }), _vm._v(" "), _c('i', {
    staticClass: "fa fa-times",
    attrs: {
      "klickart-folder-search-cancel": ""
    }
  })])
}]}


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-loader/lib/template-compiler.js?id=data-v-3bd2878c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/index/Search.vue
 ** module id = 804
 ** module chunks = 1
 **/